import { useQuery, useMutation } from '@tanstack/react-query';
import request from 'shared/lib/request';
import ServerErrorHandler from 'shared/feedback/ErrorHandler';
import { registryKeys } from './keys';

export const useRegistryUsers = (size = 1000) =>
  useQuery({
    queryKey: registryKeys.users(size),

    queryFn: async () => {
      const res = await request.get(`/registry/users?size=${size}`);
      return res.data._embedded?.users ?? [];
    },
  });

interface CreateOrganizationUserParams {
  newUser: Record<string, unknown>;
  userName: string;
  role: string;
  roleId: number;
  organizationId: number;
}

export const useCreateOrganizationUser = () =>
  useMutation({
    mutationFn: async ({ newUser, userName, role, roleId, organizationId }: CreateOrganizationUserParams) => {
      // Create user (ignore 409 — user already exists)
      await request.post('/registry/users', newUser).catch((e) => {
        if (e.status !== 409) throw e;
      });
      // Look up the user
      const res = await request.get(`/registry/users?username=${userName}`);
      const user = res.data._embedded.users[0];
      // Assign role
      await request.post(`/registry/roles/users/${user.id}`, {
        userId: user.id,
        roles: [{ id: roleId, role, type: 'EXT', externalId: '0' }],
        attributeId: organizationId,
      });
    },

    onError: ServerErrorHandler,
  });
